export default {"src":"/_next/static/media/DDOG.75c0c9b4.svg","height":18,"width":18};